import React, { Component, ChangeEvent } from "react";
import { IHeaderParams, RowSelectedEvent } from "ag-grid-community";
import { Checkbox } from "@mui/material";
import { dispatchCustomEvent } from "utils";

interface CustomHeaderState {
  checked: boolean;
}

class CustomHeader extends Component<IHeaderParams, CustomHeaderState> {
  constructor(props: IHeaderParams) {
    super(props);
    this.state = { checked: false };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.props.api.addEventListener("rowSelected", (e: RowSelectedEvent) => {
      const { checked } = this.state;
      const { node } = e;
      // if a row unselect, then uncheck
      if (!node.isSelected() && checked) {
        this.setState({ checked: false });
        dispatchCustomEvent("SELECT_ALL_CHECKBOX", { checked: false });
      }
    });

    addEventListener("DATA_LOADED", () => {
      const { checked } = this.state;
      if (checked) {
        this.props.api.forEachNode((node) => {
          node.setSelected(true);
        });
      }
    });
  }

  private onChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({ checked: e.target.checked }, () => {
      this.props.api.forEachNode((node) => {
        node.setSelected(this.state.checked);
      });
    });
    dispatchCustomEvent("SELECT_ALL_CHECKBOX", { checked: e.target.checked });
  }

  render() {
    const { checked } = this.state;
    return (
      <div
        style={{ marginLeft: -3 }}
        id="selectAllCheckBox"
      >
        <Checkbox
          style={{ padding: 0 }}
          checked={checked}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default CustomHeader;
